'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { percorsoAttivo } from '@/lib/navigazione'
import { navigazione } from '@/lib/site'
import stili from './SiteHeader.module.css'

export function SiteNav() {
  const percorso = usePathname() ?? '/'

  return (
    <nav className={stili.navigazione} aria-label="Navigazione principale">
      {navigazione.map(({ href, etichetta }) => {
        const attivo = percorsoAttivo(percorso, href)
        const classi = [stili.voce]
        if (href === '/blog') classi.push(attivo ? stili.blogAttivo : stili.blog)
        else if (attivo) classi.push(stili.voceAttiva)

        return (
          <Link
            key={href}
            href={href}
            className={classi.join(' ')}
            aria-current={attivo ? 'page' : undefined}
          >
            {etichetta}
          </Link>
        )
      })}
    </nav>
  )
}
